import { ContactsRounded } from '@mui/icons-material';
import { MenuItem, MenuItemStateProps } from '@src/components';
import { Features } from '@src/core/features';
import { useTheme } from '@src/themes';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProjectContext } from '../switch-project';

const ContactsMenu: FC<MenuItemStateProps> = ({ isMini }) => {
  const { allowedFeature } = useProjectContext();
  const { COLORS } = useTheme();
  const navigate = useNavigate();

  if (!allowedFeature(Features.CONTACTS)) {
    return <></>;
  }

  const handleClick = () => {
    navigate('/contacts', { replace: true });
  };

  return (
    <MenuItem
      isMini={isMini}
      item={{
        title: 'Contatos',
        icon: <ContactsRounded sx={{ color: COLORS.primary.main }} />,
        ignoreDefaultAvatarStyle: true,
      }}
      onClick={handleClick}
    />
  );
};

export { ContactsMenu };
